<template>
  <div class="content-body">
    <div class="container-fluid">
      <Breadcrumb name="Deposit Money" :breadcrumb="breadcrumb" />
      <!-- row -->
      <div class="row">
        <div class="col-xl-12 col-xxl-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Deposit Money</h4>
            </div>
            <div class="card-body">
              <div class="basic-form">
                <Form @submit="sendCall">
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Account</label>
                    <div class="col-sm-9">
                      <select class="form-control" v-model="selectedValet" name="valet">
                        <option :key="valetIndex" :value="valet" v-for="(valet, valetIndex) in valetData">
                          {{ valet.currency.code }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div v-if="paymentModeData" class="form-group row">
                    <label class="col-sm-3 col-form-label">Mode of Payment</label>
                    <div class="col-sm-9">
                      <select class="form-control" v-model="selectedPaymentMode" name="paymentMode">
                        <option :key="paymentModeIndex" :value="paymentMode"
                                v-for="(paymentMode, paymentModeIndex) in paymentModeData ">
                          {{ paymentMode.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div v-if="paymentModeData" class="form-group row">
                    <label class="col-sm-3 col-form-label"></label>
                    <div class="col-sm-9">
<!--                      <h6 class="cupon-pop">Fee<span> ({{fee}})</span> Total Fee: <span>{{parseFloat(totalFee).toFixed(2)}}</span></h6>-->
                      <h6 class="cupon-pop">Fee<span> ({{fee}})</span></h6>
                    </div>
                  </div>
                  <div v-if="paymentModeData" class="form-group row">
                    <label class="col-sm-3 col-form-label">Amount</label>
                    <div class="col-sm-9">
                      <Field
                          class="form-control"
                          type="text"
                          name="amount"
                          rules="required|numeric"
                      />
                      <ErrorMessage name="amount"/>
                    </div>
                  </div>
                  <div  v-if="paymentModeData" class="form-group row">
                    <div class="col-sm-10">
                      <Button class="btn btn-primary" :loading="loader" >Submit</Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    setTimeout(() => {

      this.getValetData()
    }, 1000);

  },
  data() {
    return {
      loader: false,
      emailOrPhone: '',
      selectedValet: null,
      selectedPaymentMode: null,
      valetData: [],
      paymentModeData: [],
      fee:'',
      totalFee: '',
      breadcrumb:[
        {name: 'App'},
        {name: 'Deposit Money'}
      ],

    }
  },
  methods: {
    sendCall(values) {
      let data = values
      data.userAccountId = this.selectedValet.id;
      data.paymentMethodId = this.selectedPaymentMode.id;
      data.amount = data.amount * 100
      data.type = 'DEPOSIT'

      this.loader = true
      this.makeRequest('post', 'v1/check-balance-and-limits', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            if(typeof(data.hash) != 'undefined'){
              this.$store.commit('setBalanceLimitHash',data.hash)
              this.$router.push({name: 'deposit-money-initiate'});
            }


          } else if (code == 401) {
            this.$router.push({name: 'send-otp'});
          }
        }

      });

    },
    getValetData() {
      this.makeRequest('post', 'v1/get-wallet-list', {}, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            this.valetData = responseData
            this.setSelectValetValue()
          }
        }

      });
    },
    setSelectValetValue() {
      this.valetData.forEach((obj) => {
        if (obj.is_default == 1) {
          this.selectedValet = obj
        }
      })

    }
  },
  watch: {
    selectedValet(val) {
      let data = {
        type: 'DEPOSIT',
        currencyId: val.currency_id,
      }
      this.makeRequest('post', 'v1/get-allowed-payment-methods', data, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            this.paymentModeData = responseData
            if (this.paymentModeData) {
              this.selectedPaymentMode = this.paymentModeData[0]
            }
          }
        }

      });
    },
    selectedPaymentMode(val){

      if(typeof(val.currency_payment_method[0].privileges[0]) !== 'undefined'){
        let privilege = val.currency_payment_method[0].privileges[0]
        // this.fee = '('+ parseFloat(privilege.vp_percentage_charges) + parseFloat(privilege.gw_percentage_charges) + '+' + privilege.vp_fixed_charges + privilege.gw_fixed_charges + ')'
        this.fee = parseFloat(privilege.vp_percentage_charges) + parseFloat(privilege.gw_percentage_charges)
        this.fee = parseFloat(this.fee).toFixed(2)
        let percentage_charges = this.fee
        let fixed_charges = parseFloat(parseFloat(privilege.vp_fixed_charges )+ parseFloat( privilege.gw_fixed_charges)).toFixed(2)
        this.fee = percentage_charges + '% + ' + fixed_charges/100
        this.totalFee = parseFloat(fixed_charges/100) + parseFloat((fixed_charges/100)*(percentage_charges/100))
      }

    }
  }
}
</script>

<style scoped>
.cupon-pop{
  /*font-size: 25px;*/
  margin-bottom: 20px;
  color:#222;
  /*display:inline-block;*/
  text-align:center;
  padding:10px 20px;
  border:2px dashed #222;
  clear:both;
  font-weight:normal;
}

.cupon-pop span{
  color:#03A9F4;
}

</style>

